// extracted by mini-css-extract-plugin
export default {"callback":"uiR6Y","origin":"_3raCJ","input":"gJwLO"};